import {
  tryLoadDependencies,
  WebAwesomeComponent,
} from '@/components/webcomponents/Global/loadDependency'

const faqTemplate = document.createElement('template')
faqTemplate.innerHTML = `
<wa-details>
  <span id="summary" slot="summary">
  </span>
  <slot></slot>
</wa-details>
`
class Faq extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Details])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(faqTemplate.content.cloneNode(true))
  }

  connectedCallback() {
    if (this.hasAttribute('summary')) {
      const el = this.shadowRoot?.getElementById('summary')
      if (el) {
        el.innerHTML = this.getAttribute('summary') ?? ''
      }
    }
  }
}

if (!customElements.get('ts-faq')) {
  customElements.define('ts-faq', Faq)
}
export { Faq }
